import { UnitType } from "../ecclesiastical/unit-type.enum";

export class UnitLoginResult {
  name: string;
  unitType?: UnitType;
  unitId: number;
  email: string;
}
